import { render, staticRenderFns } from "./list courses.vue?vue&type=template&id=7129dfc9&"
import script from "./list courses.vue?vue&type=script&lang=js&"
export * from "./list courses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports